import PeerSupportMisalignments from "../images/publications/is-this-really.png";
import LLMDisinformation from "../images/publications/sword-and-shield.png";
import ImNotAbleToBeThereForYou from "../images/publications/im-not-able-to-be-there-for-you.png";
import ActsOfConfiguration from "../images/publications/acts-of-configuration.png";
import RedistributingVoiceAndResponsibility from "../images/publications/redistributing-voice-responsibility.png";
import WordstoDescribe from "../images/publications/words-to-describe-what-im-feeling.png";
import PeerSupportSingapore from "../images/publications/i-said-things-peer-support-singapore.png";
import EnvisioningEcosystem from "../images/publications/envisioning-ecosystem.jpg";
import TowardsUnderstandingEmotions from "../images/publications/towards-understanding-emotions.png";
import CADiabetes from "../images/publications/ca-diabetes.jpg";
import SocialBehaviourUnderstanding from "../images/publications/social-behaviour-understanding.png";

export const publications = [
  {
    title: "\"Is This Really a Human Peer Supporter?\": Misalignments Between Peer Supporters and Experts in LLM-Supported Interactions",
    authors: "Kellie Yu Hui Sim, Roy Ka-Wei Lee, Kenny Tsu Wei Choo",
    venue: "CSCW",
    year: 2026,
    month: 10,
    tags: [
      "Full Paper"
    ],
    keywords: [
      "Mental Health",
      "Peer Support"
    ],
    comments: "To be presented as a paper presentation at CSCW 2026 in Salt Lake City, Utah, USA. Acceptance Rate: 30.5% (194/637)",
    links: {
      paper: "https://doi.org/10.1145/3816956",
      preprint: "https://arxiv.org/abs/2506.09354",
      pdf: "files/2025-is-this-really-misalignments-peer-support.pdf"
    },
    pillarIds: [
      "misalignment"
    ],
    selected: true,
    image: PeerSupportMisalignments
  },
  {
    title: "Sword and Shield: Uses and Strategies of LLMs in Navigating Disinformation",
    authors: "Gionnieve Lim, Bryan Chen Zhengyu Tan, Kellie Yu Hui Sim, Weiyan Shi, Ming Hui Chew, Ming Shan Hee, Roy Ka-Wei Lee, Simon T. Perrault, Kenny Tsu Wei Choo",
    venue: "CSCW",
    year: 2026,
    month: 10,
    tags: [
      "Full Paper"
    ],
    keywords: [
      "Disinformation"
    ],
    comments: "To be presented as a paper presentation at CSCW 2026 in Salt Lake City, Utah, USA. Acceptance Rate: 30.5% (194/637)",
    links: {
      paper: "https://doi.org/10.1145/3817008",
      preprint: "https://arxiv.org/abs/2506.07211",
      pdf: "files/2025-sword-and-shield.pdf"
    },
    pillarIds: [
      "agency"
    ],
    selected: false,
    image: LLMDisinformation
  },
  {
    title: "\"I'm Not Able to Be There for You\": Emotional Labour, Responsibility, and AI in Peer Support",
    authors: "Kellie Yu Hui Sim, Kenny Tsu Wei Choo",
    venue: "DIS",
    year: 2026,
    month: 6,
    tags: [
      "PWiP"
    ],
    keywords: [
      "Peer Support"
    ],
    comments: "Presented as a PWiP poster at DIS 2026 in Singapore, Singapore. Acceptance Rate: 38.74% (74/191).",
    links: {
      paper: "https://doi.org/10.1145/3802974.3809470",
      preprint: "http://arxiv.org/abs/2604.14007",
      poster: "files/2026-im-not-able-to-be-there-for-you.pdf"
    },
    pillarIds: [
      "reflection"
    ],
    selected: true,
    image: ImNotAbleToBeThereForYou
  },
  {
    title: "Acts of Configuration: Rethinking Provenance, Temporality and Legitimacy in Post-Mortem Agents",
    authors: "Kellie Yu Hui Sim, Pin Sym Foong, Darryl Lim, John-Henry Lim, Kenny Tsu Wei Choo",
    venue: "DIS",
    year: 2026,
    month: 6,
    tags: [
      "PWiP"
    ],
    keywords: [
      "Post-Mortem Agents",
      "Advance Care Planning"
    ],
    comments: "Presented as a PWiP poster at DIS 2026 in Singapore, Singapore. Acceptance Rate: 38.74% (74/191).",
    links: {
      paper: "https://doi.org/10.1145/3802974.3809435",
      preprint: "http://arxiv.org/abs/2604.13996",
      poster: "files/2026-acts-of-configuration.pdf"
    },
    pillarIds: [
      "agency"
    ],
    selected: true,
    image: ActsOfConfiguration
  },
  {
    title: "Redistributing Voice and Responsibility: AI in Relationship-Centred Care",
    authors: "Kellie Yu Hui Sim, Kenny Tsu Wei Choo",
    venue: "CHI Workshop on Toward Relationship-Centered Care with AI: Designing for Human Connections in Healthcare",
    year: 2026,
    month: 4,
    tags: [
      "Provocation",
      "Workshop Paper"
    ],
    keywords: [
      "Advance Care Planning",
      "Mental Health",
      "Peer Support"
    ],
    comments: "Presented as a provocation at the CHI 2026 Workshop on Toward Relationship-Centered Care with AI: Designing for Human Connections in Healthcare.",
    links: {
      preprint: "https://arxiv.org/abs/2606.00028",
      slides: "/files/260416_CHI26%20Workshop%20Presentation.pdf"
    },
    pillarIds: [
      "reflection"
    ],
    selected: false,
    image: RedistributingVoiceAndResponsibility
  },
  {
    title: "Words to Describe What I'm Feeling: Exploring the Potential of AI Agents for High Subjectivity Decisions in Advance Care Planning",
    authors: "Kellie Yu Hui Sim, Pin Sym Foong, Chenyu Zhao, Melanie Yi Ning Quek, Swarangi Subodh Mehta, Kenny Tsu Wei Choo",
    venue: "<span title=\"ACM Conference on Human Factors in Computing Systems\">CHI</span>",
    year: 2026,
    month: 4,
    tags: [
      "Conference Paper"
    ],
    keywords: [
      "Featured",
      "Advance Care Planning"
    ],
    comments: "Presented as a paper presentation at CHI 2026 in Barcelona, Spain. Acceptance Rate: 25.3% (1703/6730). Received a Honorable Mention Award (top 5% of submissions).",
    press: "Featured on <a href=\"https://scienmag.com/new-tech-enables-communication-for-nonverbal-patients/\" target=\"_blank\" rel=\"noopener noreferrer\">ScienMag</a>, <a href=\"https://bioengineer.org/new-tech-enables-communication-for-nonverbal-patients/\" target=\"_blank\" rel=\"noopener noreferrer\">Bioengineer.org</a>, and <a href=\"https://techxplore.com/news/2026-07-ai-agent-machines-patients-life.html\" target=\"_blank\" rel=\"noopener noreferrer\">TechXplore</a>",
    links: {
      preprint: "https://doi.org/10.48550/arXiv.2512.11276",
      paper: "https://doi.org/10.1145/3772318.3791335",
      pdf: "files/2026-words-to-describe-what-im-feeling.pdf"
    },
    pillarIds: [
      "reflection"
    ],
    selected: true,
    award: "Honorable Mention Award",
    proceedings: "Proceedings of the 2026 CHI Conference on Human Factors in Computing Systems",
    image: WordstoDescribe
  },
  {
    title: "Communication Games to Study Emerging Disinformation Scenarios With LLMs",
    authors: "Gionnieve Lim, Bryan Chen Zhengyu Tan, Kellie Yu Hui Sim, Weiyan Shi, Ming Hui Chew, Ming Shan Hee, Roy Ka-Wei Lee, Simon T. Perrault, Kenny Tsu Wei Choo",
    venue: "<span title=\"ACM Conference on Computer-Supported Cooperative Work and Social Computing\">CSCW</span>",
    year: 2025,
    month: 10,
    tags: [
      "Poster"
    ],
    keywords: [
      "Disinformation"
    ],
    comments: "Presented as a poster at CSCW 2025 in Bergen, Norway. Acceptance Rate: 52% (61/117).",
    links: {
      paper: "https://doi.org/10.1145/3715070.3749236",
      pdf: "files/2025-communication-games-to-study-emerging-disinformation-scenarios-with-llms.pdf",
      poster: "files/2025-communication-games-to-study-emerging-disinformation-scenarios-with-llms-poster.pdf"
    },
    pillarIds: [
      "agency"
    ],
    selected: false,
    proceedings: "Proceedings of the 2025 ACM Conference on Computer-Supported Cooperative Work and Social Computing",
    image: LLMDisinformation
  },
  {
    title: "\"I Said Things I Needed to Hear Myself\": Peer Support as an Emotional, Organisational, and Sociotechnical Practice in Singapore",
    authors: "Kellie Yu Hui Sim, Kenny Tsu Wei Choo",
    venue: "arXiv",
    year: 2025,
    month: 6,
    tags: [
      "arXiv Preprint"
    ],
    keywords: [
      "Mental Health",
      "Peer Support"
    ],
    links: {
      preprint: "https://arxiv.org/abs/2506.09362",
      pdf: "files/2025-i-said-things-peer-support-singapore.pdf"
    },
    pillarIds: [
      "reflection"
    ],
    selected: true,
    image: PeerSupportSingapore
  },
  {
    title: "Envisioning an AI-Enhanced Mental Health Ecosystem",
    authors: "Kellie Yu Hui Sim, Kenny Tsu Wei Choo",
    venue: "<span title=\"ACM CHI Conference on Human Factors in Computing Systems\">CHI</span>",
    year: 2025,
    month: 4,
    tags: [
      "Workshop Paper",
      "arXiv Preprint"
    ],
    keywords: [
      "Featured",
      "Mental Health"
    ],
    comments: "Presented as a poster at the CHI 2025 Workshop on Envisioning the Future of Interactive Health in Yokohama, Japan.",
    links: {
      preprint: "https://arxiv.org/abs/2503.14883",
      pdf: "files/2025-envisioning-an-ai-enhanced-mental-health-ecosystem.pdf",
      poster: "files/2025-envisioning-an-ai-enhanced-mental-health-ecosystem-poster.pdf"
    },
    pillarIds: [
      "reflection"
    ],
    selected: false,
    image: EnvisioningEcosystem
  },
  {
    title: "Towards Understanding Emotions for Engaged Mental Health Conversations",
    authors: "Kellie Yu Hui Sim, Kohleen Tijing Fortuno, Kenny Tsu Wei Choo",
    venue: "<span title=\"ACM Conference on Designing Interactive Systems\">DIS</span>",
    year: 2024,
    month: 7,
    tags: [
      "PWiP"
    ],
    keywords: [
      "Featured",
      "Mental Health"
    ],
    comments: "Presented as a PWiP poster at DIS 2024 in Copenhagen, Denmark. Acceptance Rate: 41.5% (47/113).",
    links: {
      paper: "https://doi.org/10.1145/3656156.3663694",
      pdf: "files/2024-towards-understanding-emotions.pdf",
      poster: "files/2024-towards-understanding-emotions-poster.pdf",
      preprint: "https://arxiv.org/abs/2406.11135"
    },
    pillarIds: [
      "reflection"
    ],
    selected: true,
    proceedings: "DIS '24 Companion: Companion Publication of the 2024 ACM Designing Interactive Systems Conference",
    image: TowardsUnderstandingEmotions
  },
  {
    title: "Designing AI-Based Conversational Agent for Diabetes Care in a Multilingual Context",
    authors: "Thuy-Trinh Nguyen, Kellie Sim, Anthony To Yiu Kuen, Ronald R. O’donnell, Suan Tee Lim, Wenru Wang, Hoang D. Nguyen",
    venue: "<span title=\"Pacific Asia Conference on Information Systems\">PACIS</span>",
    year: 2021,
    month: 7,
    tags: [
      "Conference Paper"
    ],
    keywords: [
      "Diabetes Care"
    ],
    links: {
      paper: "https://aisel.aisnet.org/pacis2021/96",
      pdf: "files/2021-designing-ai-based-conversational-agent.pdf",
      preprint: "https://arxiv.org/abs/2105.09490"
    },
    pillarIds: [
      "reflection"
    ],
    selected: false,
    proceedings: "Proceedings of the 2021 Pacific Asia Conference on Information Systems",
    image: CADiabetes
  },
  {
    title: "Social Behaviour Understanding Using Deep Neural Networks: Development of Social Intelligence Systems",
    authors: "Ethan Lim Ding Feng, Zhi-Wei Neo, Aaron William De Silva, Kellie Sim, Hong-Ray Tan, Thi-Thanh Nguyen, Karen Wei Ling Koh, Wenru Wang & Hoang D. Nguyen",
    venue: "<span title=\"International Conference on Human-Computer Interaction\">HCII</span>",
    year: 2020,
    month: 7,
    tags: [
      "Conference Paper",
      "Book Chapter"
    ],
    keywords: [
      "Mental Health"
    ],
    links: {
      paper: "https://doi.org/10.1007/978-3-030-49570-1_42",
      pdf: "files/2020-social-behaviour-understanding.pdf",
      preprint: "https://arxiv.org/abs/2105.09489"
    },
    pillarIds: [
      "reflection"
    ],
    selected: false,
    proceedings: "International Conference on Human-Computer Interaction",
    image: SocialBehaviourUnderstanding
  }
];
